import { employees, getEmployee } from "../../models/employees";
import "./employeeSelect.css";

export default function EmployeeSelect({
  selectedEmployee,
  onSelectedEmployee,
  hiddenEmployeeIds,
}) {
  return (
    <div >
      <select
        className="employeeSelect"
        value={selectedEmployee.id}
        onChange={(e) =>
          onSelectedEmployee(getEmployee(parseInt(e.target.value)))
        }
      >
        {employees.map((employee) => {
          if (hiddenEmployeeIds && hiddenEmployeeIds.includes(employee.id)) {
            return null;
          }
          return (
            <option key={employee.id} value={employee.id}>
              <b style={{ fontWeight: "600" }}>{employee.name} - {employee.level.toUpperCase()}</b>
            </option>
          );
        })}
      </select>
    </div>
  );
}
